import {useQuery} from "@tanstack/react-query";

import {safelistingsService} from "../services";

type UseResidentHomeSafelistingsAccountabilityParams = {
  enabled?: boolean;
};

export function useResidentHomeSafelistingsAccountability({
  enabled = true,
}: UseResidentHomeSafelistingsAccountabilityParams = {}) {
  const query = useQuery({
    queryKey: ["safelistings", "resident-home-accountability"],
    queryFn: () => safelistingsService.getResidentHomeAccountability(),
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });

  return {
    ...query,
    accountability: query.isSuccess ? query.data : null,
  };
}
